import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder, NgControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ContractRates, RailroadRegularTimeBasis } from 'src/shared/api';
import { filter } from 'rxjs/operators';
import { animateList } from 'src/shared/animations';
import { contractRatesFormConfig } from '../contract-rates.component';
import { CustomFormListAccessor } from '../../form-list-cva.component';
import { ContractRatesDialogComponent } from '../contract-rates-dialog/contract-rates-dialog.component';
import { BehaviorSubject } from 'rxjs';

@Component({
	selector: 'rpshared-contract-rates-list',
	templateUrl: './contract-rates-list.component.html',
	animations: [animateList],
})
export class ContractRatesListComponent extends CustomFormListAccessor<ContractRates> {
	@Input() railroadRegularTimeBasis: RailroadRegularTimeBasis;
	private _canMakeChanges: boolean;
	get canMakeChanges(): boolean {
		return this._canMakeChanges;
	}
	@Input() set canMakeChanges(value: boolean) {
		this._canMakeChanges = value;
		if (this._canMakeChanges) {
			this.resultColumns = ['service', 'edit', 'delete'];
		} else {
			this.resultColumns = ['service', 'view'];
		}
	}

	private readonly applyPrevailingWage$ = new BehaviorSubject<boolean>(false);
	@Input()
	set isApplyPrevailingWage(isApplyPrevailingWage: boolean) {
		this.applyPrevailingWage$.next(isApplyPrevailingWage);
	}

	readonly emptyColumns = ['empty'];
	resultColumns = ['service'];

	constructor(
		public ngControl: NgControl,
		public fb: FormBuilder,
		private readonly dialog: MatDialog
	) {
		super(ngControl, fb, contractRatesFormConfig);
	}

	addContractRates() {
		this.dialog
			.open<
				ContractRatesDialogComponent,
				{
					contractRates?: ContractRates;
					readonly: boolean;
					railroadRegularTimeBasis: RailroadRegularTimeBasis;
					isApplyPrevailingWage: boolean;
				},
				FormGroup
			>(ContractRatesDialogComponent, {
				width: '900px',
				data: {
					readonly: false,
					railroadRegularTimeBasis: this.railroadRegularTimeBasis,
					isApplyPrevailingWage: this.applyPrevailingWage$.value,
				},
			})
			.afterClosed()
			.pipe(filter((control) => !!control))
			.subscribe((control) => {
				this.array.insert(0, control);
			});
	}

	editContractRates(rates: ContractRates) {
		this.dialog
			.open<
				ContractRatesDialogComponent,
				{
					contractRates: ContractRates;
					readonly: boolean;
					railroadRegularTimeBasis: RailroadRegularTimeBasis;
					isApplyPrevailingWage: boolean;
				},
				FormGroup
			>(ContractRatesDialogComponent, {
				width: '900px',
				data: {
					contractRates: rates,
					readonly: false,
					railroadRegularTimeBasis: this.railroadRegularTimeBasis,
					isApplyPrevailingWage: this.applyPrevailingWage$.value,
				},
			})
			.afterClosed()
			.pipe(filter((control) => !!control))
			.subscribe((control) => {
				this.array.setControl(
					this.findContractRatesIndex(rates),
					control
				);
			});
	}

	viewContractRates(rates: ContractRates) {
		this.dialog
			.open<
				ContractRatesDialogComponent,
				{ contractRates: ContractRates; readonly: boolean },
				FormGroup
			>(ContractRatesDialogComponent, {
				width: '900px',
				data: {
					contractRates: rates,
					readonly: true,
				},
			})
			.afterClosed()
			.pipe(filter((control) => !!control))
			.subscribe((control) => {
				this.array.setControl(
					this.findContractRatesIndex(rates),
					control
				);
			});
	}

	findContractRatesIndex(contract: ContractRates) {
		return this.dataSource.data.findIndex((c) => c === contract);
	}
}
